import { z } from 'zod';
import type { applicationSchema } from './application.schema';

export const AUTH_METHOD_OPTIONS = [
    { value: 'regular', label: 'Regular' },
    { value: 'NBC', label: 'NBC (SSO)' },
    { value: 'NFL', label: 'NFL (SSO)' },
    { value: 'VISA', label: 'VISA (SSO)' },
    { value: 'ALPINE', label: 'ALPINE (SSO)' },
    { value: 'MERCEDES', label: 'MERCEDES (SSO)' },
    { value: 'NEWCASTLE', label: 'NEWCASTLE (SSO)' },
] as const;

export const authMethodInputSchema = z.object({
    method: z.enum(['regular', 'sso']),
    value: z.string().optional(),
});

export type AuthMethodInput = z.infer<typeof authMethodInputSchema>;

export const applicationCreateInputSchema = z.object({
    name: z.string().min(2, 'Name must be at least 2 characters').max(100, 'Name must not exceed 100 characters'),
    identifier: z
        .string()
        .min(3, 'Identifier must be at least 3 characters')
        .max(8, 'Identifier must not exceed 8 characters')
        .regex(/^[A-Z0-9]+$/, 'Identifier must contain only uppercase letters and numbers')
        .refine((value) => !value.startsWith('INTERNAL'), {
            message: 'Identifier must not start with INTERNAL',
        }),
    templateAccountId: z.string().optional(),
    authMethods: z.array(authMethodInputSchema).optional(),
    adminId: z.string().max(255, 'Master ID must not exceed 255 characters').optional(),
});

export type ApplicationCreateInput = z.infer<typeof applicationCreateInputSchema>;

export type ApplicationCreateResponse = z.infer<typeof applicationSchema>;
